// ─── API ─────────────────────────────────────────────────────────────────────
export const API_BASE_URL = 'https://api2.nekonik.com/json-viewer';

// ─── Cloudflare Turnstile ─────────────────────────────────────────────────────
// Set REACT_APP_CF_TURNSTILE_SITE_KEY in your .env file.
// Use '1x00000000000000000000AA' (always-passes dummy) for local development.
export const CF_TURNSTILE_SITE_KEY = '0x4AAAAAAC8XWNeUpN0H3YZP';

// ─── App Metadata ─────────────────────────────────────────────────────────────
export const ABOUT_URL = 'https://www.nekonik.com/about';

// ─── Download ─────────────────────────────────────────────────────────────────
export const DOWNLOAD_FILENAME = 'NekoNik-modified.json';
